/**
 * 意见反馈表单页懒加载壳（14.35b；AboutLazy 同构）：低频页不进首屏 bundle。
 * target=举报预填（14.35d），原样透传给页面。
 */
import { useLazyModule } from './useLazyModule';
import type { FeedbackTarget } from '~/nav/routes';

export function FeedbackLazy({ target }: { target?: FeedbackTarget }) {
  const { mod } = useLazyModule(() => import('./FeedbackPage'));
  if (mod === null) return <div data-testid="feedback-loading-shell">加载中…</div>;
  return <mod.FeedbackPage {...(target ? { target } : {})} />;
}
